import * as React from 'react';

const ChevronUp24: React.FC<React.SVGProps<SVGSVGElement>> = () => (
	<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
		<path
			d='M6 14L11.7173 8.12053C11.7544 8.08232 11.7985 8.05201 11.847 8.03133C11.8955 8.01064 11.9475 8 12 8C12.0525 8 12.1045 8.01064 12.153 8.03133C12.2015 8.05201 12.2456 8.08232 12.2827 8.12053L18 14'
			stroke='currentColor'
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

export default ChevronUp24;
